import React from "react";

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="loader-top"></div>
        <div className="loader-bottom"></div>
      </div>
    </div>
  );
}

export default Loader;
